module.exports = __webpack_public_path__ + "img/4fce6.f916477b.svg";